<template>
  <main class="research" v-if="payload">
    <div class="research__information">
      <div class="research__information-about">
        <h1 v-html="payload.research.title" class="title ff-sans fs-l"></h1>
        <p v-html="payload.research.description"></p>
      </div>
      <div class="research__information-tags">
        <p class="tags ttu">Tags</p>
        <ul>
          <li v-for="(tag, key) in payload.research.tags" :key="`tag${key}`">
            <router-link :to="`/tags/${tag.slug}`" v-html="tag.name"></router-link>
          </li>
        </ul>
      </div>
      <div
        v-if="designers && payload.research.year"
        class="research__information-meta">
        <p
          v-if="designers.length > 1"
          class="meta meta--designer ttu">Designers</p>
        <p
          v-else
          class="meta meta--designer ttu">Designer</p>
        <p v-for="(designer, key) in designers" :key="`designer${key}`">
          <router-link :to="designer.link" v-html="designer.name"></router-link>
        </p>
        <p class="meta meta--year" v-html="payload.research.year"></p>
      </div>
    </div>
    <div class="research__slideshow" :class="{'research__slideshow--active': slideshowToggle}">
      <div
        class="slideshow"
        @click.self="slideshowToggle = false"
        :width="imageWidth"
        :height="imageHeight">
        <div
          class="slideshow__item"
          v-for="(slide, key) in payload.research.slideshow"
          :class="{'slideshow__item--active': key === active}"
          :key="`slide${key}`">
          <div
            v-if="slide.type === 'image'"
            class="slideshow__item-image">
            <img :src="slide.image.url" />
          </div>
          <div
            v-if="slide.type === 'video'"
            class="slideshow__item-video">
            <video
              playsinline
              muted
              loop>
              <source
                :src="slide.video"
                type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="slideshow__controls">
          <div
            class="slideshow__controls--prev"
            @click="prevItem()"></div>
          <div
            class="slideshow__controls--next"
            @click="nextItem()"></div>
        </div>
      </div>
      <div class="research__slideshow-index">
        <p v-html="`(${active + 1} / ${payload.research.slideshow.length})`"></p>
        <p v-if="payload.research.slideshow[active].caption" v-html="payload.research.slideshow[active].caption"></p>
      </div>
    </div>
    <div class="research__description">
       <p v-html="payload.research.description"></p>
    </div>
    <div class="research__tags">
      <p class="tags ttu">Tags</p>
      <ul>
        <li v-for="(tag, key) in payload.research.tags" :key="`tag${key}`">
          <router-link :to="`/tags/${tag.slug}`" v-html="tag.name"></router-link>
        </li>
      </ul>
    </div>
    <button class="research__toggle" v-html="buttonText" @click="slideshowToggle = !slideshowToggle"></button>
  </main>
</template>

<script>
import DataService from '@/services/data-service'
import MetaService from '@/services/meta-service'

export default {
  name: 'ResearchSingle',
  data() {
    return {
      slideshowToggle: true,
      buttonText: '(text)',
      payload: null,
      active: 0,
      totalItems: null,
      imageWidth: null,
      imageHeight: null
    }
  },
  watch: {
    slideshowToggle: function(newVal) {
      if (newVal) {
        this.buttonText = '(text)'
      } else {
        this.buttonText = '(images)'
      }
    },
    active: function(newVal) {
      let mediaList = document.querySelectorAll('.slideshow img, .slideshow video')
      let controlsContainer = document.querySelector('.slideshow__controls')

      // do updates after a short timeout
      setTimeout(() => {
        this.imageWidth = mediaList[newVal].offsetWidth
        this.imageHeight = mediaList[newVal].offsetHeight

        if (mediaList[newVal].nodeName === 'VIDEO' || mediaList[newVal].nodeName === '<video>') {
          mediaList[newVal].play()
        }

        controlsContainer.style.width = `${mediaList[newVal].offsetWidth}px`
        controlsContainer.style.height = `${mediaList[newVal].offsetHeight}px`
      }, 20)
    },
    'payload.research': function(newVal) {
      if (newVal) {
        if (newVal.designers) {
          this.designers = newVal.designers.map((designer) => {
            return {
              name: `${designer.first_name} ${designer.last_name}`,
              link: `/designers/${designer.slug}`
            }
          })
        }

        if (newVal.slideshow) {
          this.totalItems = newVal.slideshow.length

          setTimeout(() => {
            let mediaList = document.querySelectorAll('.slideshow img, .slideshow video')
            let controlsContainer = document.querySelector('.slideshow__controls')

            controlsContainer.style.width = `${mediaList[this.active].offsetWidth}px`
            controlsContainer.style.height = `${mediaList[this.active].offsetHeight}px`
          }, 100)
        }
      }
    }
  },
  methods: {
    setData(payload) {
      this.payload = payload
      MetaService.updateMeta(payload)
    },
    prevItem() {
      if (!this.slideshowToggle) return false

      setTimeout(() => {
        if (this.active === 0) this.active = this.totalItems - 1
        else this.active -= 1
      }, 400)
    },
    nextItem() {
      if (!this.slideshowToggle) return false

      setTimeout(() => {
        if (this.active === this.totalItems - 1) this.active = 0
        else this.active += 1
      }, 400)
    }
  },
  beforeRouteUpdate(to, from, next) {
    to.meta.postData.research = to.params.research

    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        this.setData(payload)
        next()
      })
  },
  beforeRouteEnter(to, from, next) {
    to.meta.postData.research = to.params.research

    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        next(vm => {
          vm.setData(payload)
        })
      })
  }
}
</script>

<style lang="scss" scoped>
.research {
  @include page;

  &__information {
    display:flex;
    &-about {
      width:50%;
      padding:0 $grid-padding 0 0;
    }
    &-tags, &-meta {
      width:25%;
      a {
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  &__slideshow {
    // position:fixed;
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    filter:blur(30px);
    z-index: -1;
    opacity: 0.65;
    transition:filter 200ms ease-in-out, opacity 200ms ease-in-out;

    &--active {
      filter: blur(0px);
      opacity: 1;
      z-index: 100;
      cursor: zoom-out;
    }

    .slideshow {
      position:relative;
      width:100%;
      height:100%;
      max-height: 100vh;
      &__item {
        display:none;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%, calc(-50% + 2rem));
        &-image, &-video {
          max-height:100vh;
          cursor: pointer;
        }
        img, video {
          width:auto;
          max-height:85vh;
        }
        video {
          max-width:75vw;
        }
        &--active {
          display:block;
        }
      }
      &__controls {
        opacity:0;
        height:100%;
        width:100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, calc(-50% + 2rem));
        display:flex;
        &--prev {
          width:50%;
          cursor:w-resize;
        }
        &--next {
          width:50%;
          cursor:e-resize;
        }
      }
    }
    &-index {
      @include caption_style2;
    }
  }
  &__toggle {
    @include button_reset;
    position:fixed;
    top:50%;
    right:$padding;
    transform:translateY(-50%);
  }
  &__description, &__tags {
    display:none;
  }
  @media screen and (max-width: $mobile) {
    &__information {
      flex-wrap:wrap;
      &-about {
        width:100%;
        order:1;
        font-size:$body--m;
        p {
          &:last-child {
            display:none;
          }
        }
      }
      &-meta {
        width:100%;
        order:2;
        font-size:$body--m;
        .meta {
          &--designer {
            display:none;
          }
        }
      }
      &-tags {
        display:none;
      }
    }
    &__slideshow {
      width:100%;
      margin:0.5rem 0;
      position:relative;
      .slideshow {
        position:relative;
        &__item {
          position:relative;
          transform: none;
          top:0;
          left:0;
          &-image, &-video {
            width:100%;
            height:calc((100vw - 1.5rem) / 1.5);
            cursor: pointer;
            img, video {
              object-position: 0% 100%;
              height: 100%;
            }
          }
          &-video {
            video {
              width:100%;
              max-height:unset;
              max-width:unset;
            }
          }
        }

        &__controls {
          width:100% !important;
          height:100% !important;
          top:0px;
          left:0px;
          transform:unset;
        }
      }
      &-index {
        position:relative;
        padding:0;
        display:flex;
        flex-direction: column;
        font-size: 14px;
        min-height:unset;
        align-items: flex-start;
        justify-content: flex-start;
        font-weight:normal;
        p {
          padding: 0.5rem 0 0 0;
          font-weight:normal;
          &:first-child {
            width:100%;
            text-align: left;
          }
        }
      }
    }
    &__toggle {
      display:none;
    }
    &__description {
      display:flex;
      width:100%;
      p {
        font-size:$body--m;
      }
    }
    &__tags {
      width:100%;
      order:3;
      margin:1rem 0 0 0;
      font-size:$body--m;
      display:block;
      ul {
        display:flex;
        flex-wrap:wrap;
        li {
          display:flex;
          margin:0 0.25rem 0 0;
          &:after {
            content:',';
            display:block;
            position:relative;
          }
          &:last-child {
            &:after {
              display:none;
            }
          }
        }
      }
    }
  }
}
</style>
